import { render, staticRenderFns } from "./Cooler.vue?vue&type=template&id=492f18ce"
import script from "./Cooler.vue?vue&type=script&lang=js"
export * from "./Cooler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports